import { useMemo } from 'react';

import { notEmpty } from '@futrli/shared-services';

import { CATEGORY_NAME_INDEXES } from '../../../../core/constants';
import { ConsolidatedForecastReport, ConsolidatedForecastReportTab } from '../../../../core/types';
import { usePredictionsInfoContext } from '../../context/predictions-info-context';
import { useSubTabNameMaps } from './useSubTabNameMaps';

/**
 * Hook to get category options and the selected category ID for a given forecast tab
 */
export const useCategoryOptions = (
  forecastReport: ConsolidatedForecastReport | null | undefined,
  tab: ConsolidatedForecastReportTab
) => {
  const { category } = usePredictionsInfoContext();
  const { categoryNames } = useSubTabNameMaps();

  const { categoryOptions, categoryIds } = useMemo(() => {
    const categoryIds = tab.children
      .map(child => forecastReport?.node_info.by_ref[child.ref].static_id)
      .filter(notEmpty);
    const categoryOptions = categoryIds.map(categoryId => ({
      name: tab.label || categoryNames[tab.id || '']?.[categoryId] || '',
      value: categoryId
    }));

    return { categoryOptions, categoryIds };
  }, [categoryNames, forecastReport, tab]);

  const selectedCategoryId = (category && categoryIds.includes(category)
    ? category
    : categoryIds[0]) as CATEGORY_NAME_INDEXES;

  return {
    categoryOptions,
    selectedCategoryId,
    categoryIds
  };
};
